import {
  SEARCH_ELEMENT_FAILURE,
  SEARCH_ELEMENT_REQUEST,
  SEARCH_ELEMENT_SUCCESS,
} from '../types/searchTypes';
import { requestGetApi } from '../../services/api/api';
import { BASE_API_URL } from '../../constants/constants';

const searchElementRequest = (searchValue) => ({
  type: SEARCH_ELEMENT_REQUEST,
  payload: searchValue,
});

const searchElementSuccess = ({
  courses,
  course_modules,
  module_sections,
  module_section_videos,
  module_section_screeners,
}) => ({
  type: SEARCH_ELEMENT_SUCCESS,
  payload: { courses, course_modules, module_sections, module_section_videos, module_section_screeners },
});

const searchElementFailure = (error) => ({
  type: SEARCH_ELEMENT_FAILURE,
  payload: error,
});

export const onSearchElement = (
  searchValue,
  favoriteSectionIsOpen = false,
  isHelpCenter = false
) => {
  return async (dispatch) => {
    dispatch(searchElementRequest(searchValue));

    const search_by = (!favoriteSectionIsOpen && !isHelpCenter)
      ? '1'
      : favoriteSectionIsOpen ? '1' : '3';

    try {
      const [screenerData, moduleSectionVideoData] = await Promise.all([
        searchValue !== '' ?
          requestGetApi(`${BASE_API_URL}/screeners/global_search_screeners?search=${searchValue}&search_by=${search_by}`)
          : Promise.resolve({ screeners: [] }),
        searchValue !== '' ?
          requestGetApi(`${BASE_API_URL}/module_section_videos/global_search?search=${searchValue}&search_by=${search_by}`)
          : Promise.resolve({ module_section_videos: [] })
      ]);

      // console.log('Received screeners:', screenerData);
      // console.log('Received module section videos:', moduleSectionVideoData);

      dispatch(
        searchElementSuccess({
          courses: [],
          course_modules: [],
          module_sections: [],
          module_section_videos: moduleSectionVideoData.module_section_videos,
          module_section_screeners: screenerData.screener,
        })
      );
    } catch (ex) {
      console.error('Error fetching data:', ex);
      dispatch(searchElementFailure('Error searching elements'));
    }
  };
};
